module.exports = __webpack_public_path__ + "static/media/collapse-icon.660da8d6.svg";